import { Merchandise, ProposalType, Waypoint } from 'interfaces'

export type LoginPayload = {
  username: string
  password: string
  slug: string
}

export function customPageLogin(payload: LoginPayload) {
  const { password, slug, username } = payload

  const data = new FormData()
  data.append('_username', username)
  data.append('_password', password)
  return {
    url: `/api/login_custom_page?slug=${slug}`,
    method: 'POST',
    headers: {
      Accept: 'application/json',
    },
    body: data,
  }
}

export function getCustomSettingsBySlug(slug: string) {
  return {
    url: `/api/login_custom_page/${slug}`,
    method: 'GET',
    headers: {
      Accept: 'application/ld+json',
    },
  }
}

export type CreateDeliveryPayload = {
  vehicleLoadType: string
  pickupWaypoints: Waypoint[]
  receiptWaypoints: Waypoint[]
  merchandise: Merchandise[]
  transportRules: Record<string, boolean>
  options: Record<string, boolean>
  tender: string
  receiptComment: string
  proposalType: ProposalType
}

export function customEstimate({ payload, slug }: { payload: CreateDeliveryPayload; slug: string }) {
  return {
    url: `/api/custom_page_user/estimate?slug=${slug}`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}

export function customDeliveryCreation({ payload, slug }) {
  return {
    url: `/api/custom_page_user/delivery?slug=${slug}`,
    method: 'POST',
    headers: {
      Accept: 'application/ld+json',
      'Content-Type': 'application/json',
      Authorization: null,
    },
    body: JSON.stringify(payload),
  }
}
